import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSelectArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 12 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#17181A"
    {...props}
  >
    <path d="m1 1 5.033 4L11 1" strokeLinecap="round" />
  </svg>
);
const Memo = memo(SvgSelectArrow);
export default Memo;
